export default __webpack_public_path__ + "static/media/signum.2d66cdc0.png";